import Vue from "vue";
import { ForbiddenException, HttpException, InternalServerErrorException } from "@/lib/exceptions/http";
import ExceptionToastContent from "@/components/utility/ExceptionToastContent.vue";
import vuetify from "@/plugins/VuetifyPlugin";

export function toastException(error: HttpException, showMail = true) {
  Vue.$toast.error(
    Vue.extend({
      vuetify,
      render(createElement) {
        return createElement(ExceptionToastContent, { props: { error, showMail } });
      }
    })
  );
}
export function handleError(error: any) {
  Vue.$log?.error?.(error);
  if (error instanceof HttpException) {
    if (error instanceof InternalServerErrorException || error instanceof ForbiddenException) {
      toastException(error);
    } else {
      Vue.$toast.error(error.message);
    }
  }
}
